import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { Image } from "../../../foundations/Image/Image";
import { buildImageSizes } from "../../../foundations/Image/utils/buildImageSizes";
import { buildImageSrcSet } from "../../../foundations/Image/utils/buildImageSrcSet";
import * as styles from "./FloatingBannerImage.styles";
var aspectRatioPropStylesMap = {
  '1 / 1': styles.ar11,
  '4 / 3': styles.ar43,
  '16 / 9': styles.ar169,
  auto: styles.arAuto
};
export var FloatingBannerImage = function FloatingBannerImage(_ref) {
  var _images$;
  var imageAlt = _ref.imageAlt,
    _ref$imageAspectRatio = _ref.imageAspectRatio,
    imageAspectRatio = _ref$imageAspectRatio === void 0 ? '16 / 9' : _ref$imageAspectRatio,
    imageHeight = _ref.imageHeight,
    imageWidth = _ref.imageWidth,
    images = _ref.images,
    lazyImages = _ref.lazyImages,
    offset = _ref.offset;
  var imagesWithUnit = images.map(function (_ref2) {
    var src = _ref2.src,
      width = _ref2.width;
    return {
      src,
      width,
      unit: 'w'
    };
  });
  var aspectRatioStyle = aspectRatioPropStylesMap[imageAspectRatio] || aspectRatioPropStylesMap.auto;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [styles.imageContainer, offset && styles[offset]]
  }, /*#__PURE__*/React.createElement(_StyledImage, {
    alt: imageAlt,
    height: imageHeight,
    loading: lazyImages ? 'lazy' : 'eager',
    sizes: buildImageSizes({
      XXS: '100vw',
      M: '50vw',
      XL: '566px'
    }),
    src: (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.src,
    srcSet: buildImageSrcSet(imagesWithUnit),
    width: imageWidth,
    $_css2: [styles.image, aspectRatioStyle]
  }));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledImage = /*#__PURE__*/_styled2(Image).withConfig({
  displayName: "FloatingBannerImage___StyledImage",
  componentId: "sc-1mhr5ym-0"
})(["", ""], function (p) {
  return p.$_css2;
});